export enum OrderStatusEnum {
    CANCELLED = 1,
    COMPLETED = 2,
    ERROR = 3,
    IN_PROGRESS = 4,
    INCOMPLETE = 5,
    NOT_RECEIVED = 6,
    PARTIAL_COMPLETED = 7,
    PROBE_ARRIVED = 8,
    RECEIVED = 9,
    RECEIVED_AWAITING_PROBE = 10,
    RECEIVED_PARTIAL_ORDER = 11,
}

export const orderStatusLabelTooltip: {
    [key in OrderStatusEnum]: { id: number; label: string; tooltip: string };
} = {
    [OrderStatusEnum.CANCELLED]: {
        id: OrderStatusEnum.CANCELLED,
        label: 'orders.status.cancelled',
        tooltip: '',
    },
    [OrderStatusEnum.COMPLETED]: {
        id: OrderStatusEnum.COMPLETED,
        label: 'orders.status.completed',
        tooltip: 'orders.statusTooltip.completed',
    },
    [OrderStatusEnum.ERROR]: {
        id: OrderStatusEnum.ERROR,
        label: 'orders.status.error',
        tooltip: '',
    },
    [OrderStatusEnum.INCOMPLETE]: {
        id: OrderStatusEnum.INCOMPLETE,
        label: 'orders.status.incomplete',
        tooltip: 'orders.statusTooltip.incomplete',
    },
    [OrderStatusEnum.IN_PROGRESS]: {
        id: OrderStatusEnum.IN_PROGRESS,
        label: 'orders.status.inProgress',
        tooltip: 'orders.statusTooltip.inProgress',
    },
    [OrderStatusEnum.NOT_RECEIVED]: {
        id: OrderStatusEnum.NOT_RECEIVED,
        label: 'orders.status.notReceived',
        tooltip: 'orders.statusTooltip.notReceived',
    },
    [OrderStatusEnum.PARTIAL_COMPLETED]: {
        id: OrderStatusEnum.PARTIAL_COMPLETED,
        label: 'orders.status.partiallyCompleted',
        tooltip: 'orders.statusTooltip.partiallyCompleted',
    },
    [OrderStatusEnum.PROBE_ARRIVED]: {
        id: OrderStatusEnum.PROBE_ARRIVED,
        label: 'orders.status.probeArrived',
        tooltip: 'orders.statusTooltip.probeArrived',
    },
    [OrderStatusEnum.RECEIVED]: {
        id: OrderStatusEnum.RECEIVED,
        label: 'orders.status.received',
        tooltip: 'orders.statusTooltip.received',
    },
    [OrderStatusEnum.RECEIVED_AWAITING_PROBE]: {
        id: OrderStatusEnum.RECEIVED_AWAITING_PROBE,
        label: 'orders.status.receivedAwaitingProbe',
        tooltip: 'orders.statusTooltip.receivedAwaitingProbe',
    },
    [OrderStatusEnum.RECEIVED_PARTIAL_ORDER]: {
        id: OrderStatusEnum.RECEIVED_PARTIAL_ORDER,
        label: 'orders.status.receivedPartialOrder',
        tooltip: 'orders.statusTooltip.receivedPartialOrder',
    },
};
